import config from '../../../../config';
import { RoleModel } from '../../../domainModels/roles/RoleModel';
import { axiosInstance as axios } from '../../axios/axiosInstance';

export const rolesEndpoint = `${config.tachoAPI.url}/Roles`;

export const getRoles = (): Promise<Array<RoleModel>> => {
    return axios
        .get<Array<RoleModel>>(rolesEndpoint)
        .then(response => {
            return response.data;
        })
        .catch(err => {
            throw Error(getRoles.name + err);
        });
};
